<template>
	<div class="casediv">
		<el-row :gutter="0" type="flex" class="row-bg" justify="center">
			<el-col :xs="15" :sm="5" :md="5" :lg="5" :xl="6">
				<div class="divcenter-f">{{ this.user.typeName }}</div>
			</el-col>
			<el-col :xs="6" :sm="2" :md="2" :lg="2" :xl="3">
				<div class="divcenter-f">{{ this.user.name }}</div>
			</el-col>
			<el-col :xs="15" :sm="5" :md="5" :lg="5" :xl="6">
				<div class="divcenter-f">{{ now }}</div>
			</el-col>
		</el-row>

		<el-row v-if="this.user.type == 1 && tmciShowFlg == 'SECTION'" :gutter="10" type="flex" class="row-bg" justify="center">

			<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
				<div class="grid-content bg-purple-dark divcenter" @click="caseTabelClick('SECTION')">分室案件</div>
			</el-col>
		</el-row>
		<el-row v-if="this.user.type == 1 && tmciShowFlg == 'LEADER'" :gutter="10" type="flex" class="row-bg"
		 justify="center">
			<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
				<div class="grid-content bg-purple divcenter" @click="caseTabelClick('LEADER')">我的案件</div>
			</el-col>
		</el-row>
		<el-row @click.native="changeField1" v-if="this.user.type == 1 && tmciShowFlg == 'ALL'" :gutter="10" type="flex" class="row-bg" justify="center">
			<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
				<div :class="{'grid-content':true, 'bg-purple-light':true, 'divcenter': true, 'active': active}">全国案件</div>
			</el-col>
		</el-row>
		<el-row v-if="areaList.length>0">
			<el-radio-group v-model="tab" @change="changeField" style="margin-bottom: 30px;">
				<el-radio-button v-for="(item, index) in areaList" :key="index" :label="item.field">{{item.fueldname}}</el-radio-button>
			</el-radio-group>
		</el-row>
		<div class="myCase" :class="{divBack:tabelmsg.indexOf('我的案件') != -1}">
			<el-row v-if="this.user.type == 2" type="flex" class="row-bg" justify="center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<router-link to="../addedCase/0">
							<div class="grid-content bg-purple divleft addCase">
								发起案件
							</div>
						</router-link>
					</div>
				</el-col>
			</el-row>
			<el-row type="flex" class="row-bg" justify="center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<div class="bg-purple-new divleft">
							新案件
							<span class="bgr">{{ count_新案件 }}</span>
						</div>
					</div>
					<div class="bg-purple-new bg-purple-new-item">
						<router-link to="newsCase/1">
							<div class="bg-purple-new divleft">
								技术支援申请
								<span class="bgr">{{ count_新案件_技术支援申请 }}</span>
							</div>
						</router-link>
					</div>
					<div class="bg-purple-new bg-purple-new-item">
						<router-link :to="{path:'/alarmList',query: {status: '12'}}">
							<div class="bg-purple-new divleft">
								三包预警
								<span class="bgr">{{ count_新案件_三包预警 }}</span>
							</div>
						</router-link>
					</div>
					<div class="bg-purple-new bg-purple-new-item">
						<router-link :to="{path:'/alarmList',query: {status: '13'}}">
							<div class="bg-purple-new divleft">
								三包预警发起
								<span class="bgr">{{ count_新案件_三包预警发起 }}</span>
							</div>
						</router-link>
					</div>
					<div class="bg-purple-new bg-purple-new-item">
						<router-link :to="{path:'/alarmList',query: {status: '14'}}">
							<div class="bg-purple-new divleft">
								建议发起案件
								<span class="bgr">{{ count_新案件_建议发起案件 }}</span>
							</div>
						</router-link>
					</div>
				</el-col>
			</el-row>
			<!-- <el-row type="flex" class="row-bg" justify="center" v-if="user.type == 1">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<router-link to="newsCase/1">
							<div class="bg-purple-new divleft">
								新案件
								<span class="bgr">{{ untreated }}</span>
							</div>
						</router-link>
					</div>
				</el-col>
			</el-row> -->
			<el-row type="flex" class="row-bg" justify="center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<div class="bg-purple-new divleft">
							处理中案件
							<span class="bgr">{{ count_处理中案件 }}</span>
						</div>
						<div class="bg-purple-new bg-purple-new-item">
							<router-link to="handlingCase">
								<div class="bg-purple-new divleft">
									技术支援申请
									<span class="bgr">{{ count_处理中案件_技术支援申请 }}</span>
								</div>
							</router-link>
						</div>
						<div class="bg-purple-new bg-purple-new-item">
							<router-link :to="{path:'/alarmList',query: {status: '22'}}">
								<div class="bg-purple-new divleft">
									三包预警
									<span class="bgr">{{ count_处理中案件_三包预警 }}</span>
								</div>
							</router-link>
						</div>
						<div class="bg-purple-new bg-purple-new-item">
							<router-link :to="{path:'/alarmList',query: {status: '23'}}">
								<div class="bg-purple-new divleft">
									三包预警发起
									<span class="bgr">{{ count_处理中案件_三包预警发起 }}</span>
								</div>
							</router-link>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row type="flex" class="row-bg" justify="center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<div class="bg-purple-new divleft">
							历史案件
							<span class="bgr">{{ count_历史案件 }}</span>
						</div>
						<div class="bg-purple-new bg-purple-new-item">
							<router-link to="newsCase/3">
								<div class="bg-purple-new divleft">
									技术支援申请
									<span class="bgr">{{ count_历史案件_技术支援申请 }}</span>
								</div>
							</router-link>
						</div>
						<div class="bg-purple-new bg-purple-new-item">
							<router-link  :to="{path:'/alarmList',query: {status: '32'}}">
								<div class="bg-purple-new divleft">
									三包预警
									<span class="bgr">{{ count_历史案件_三包预警 }}</span>
								</div>
							</router-link>
						</div>
						<div class="bg-purple-new bg-purple-new-item">
							<router-link :to="{path:'/alarmList',query: {status: '33'}}">
								<div class="bg-purple-new divleft">
									三包预警发起
									<span class="bgr">{{ count_历史案件_三包预警发起 }}</span>
								</div>
							</router-link>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row type="flex" class="row-bg" justify="center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
							<div class="bg-purple-new">
								<router-link :to="{path:'/alarmList',query: {status: '41'}}">
									<div class="bg-purple-new divleft">
										案件关闭
										<span class="bgr">{{ count_结案_三包预警发起_案件关闭 }}</span>
									</div>
								</router-link>
							</div>
					</div>
				</el-col>
			</el-row>
			<el-row v-if="this.user.type == 2" type="flex" class="row-bg" justify="center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
							<div class="bg-purple-new divleft">
								草稿箱
								<span class="bgr">{{ count_草稿 }}</span>
							</div>
							<div class="bg-purple-new  bg-purple-new-item">
								<router-link to="newsCase/0">
									<div class="bg-purple-new divleft">
										技术支援草稿箱
										<span class="bgr">{{ draft }}</span>
									</div>
								</router-link>
							</div>
							<div class="bg-purple-new  bg-purple-new-item">
								<router-link :to="{path:'/alarmList',query: {status: '0'}}">
									<div class="bg-purple-new divleft">
										三包预警草稿箱
										<span class="bgr">{{ count_草稿_三包预警 }}</span>
									</div>
								</router-link>
							</div>
					</div>
				</el-col>
			</el-row>
			<el-row type="flex" class="row-bg" justify="center" v-if="user.type == 1">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<router-link to="favour/5">
							<div class="bg-purple-new divleft">
								收藏夹
								<span class="bgr">{{ favour }}</span>
							</div>
						</router-link>
					</div>
				</el-col>
			</el-row>
			<el-row v-if="showbtn" type="flex" class="row-bg" justify="center">
				<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
					<router-link to="restDay">
						<el-button type="primary">休息日维护</el-button>
					</router-link>
				</el-col>
				<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
					<router-link to="setWorkingHours">
						<el-button type="primary">工作时间设置</el-button>
					</router-link>
				</el-col>
			</el-row>
			<el-row v-if="showbtn" type="flex" class="row-bg" justify="center">
				<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
					<router-link to="excel">
						<el-button type="primary">非三包预警相关案件导出</el-button>
					</router-link>
				</el-col>
				<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
					<router-link to="alarmExcel">
						<el-button type="primary">三包预警相关案件导出</el-button>
					</router-link>
				</el-col>
			</el-row>
			<el-row v-if="showbtn" type="flex" class="row-bg" justify="center">
				<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
					<router-link to="niceCase">
						<el-button type="primary">好事例管理</el-button>
					</router-link>
				</el-col>
			</el-row>
			<el-row v-if="showbtn||user.level==='SECTION'" type="flex" class="row-bg" justify="center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<router-link to="dandangguanli">
						<el-button type="primary">担当管理</el-button>
					</router-link>
				</el-col>
			</el-row>
		</div>
		<div class="compartmentCase" :class="{divBack:tabelmsg.indexOf('分室案件') != -1}">分室案件</div>
		<div class="allCase" :class="{divBack:tabelmsg.indexOf('全国案件') != -1}">全国案件</div>
	</div>
</template>
<script>
import {
  mapState
} from 'vuex'

import {
  getCountList,
  switchLevel,
  getAreaList,
  switchLevels,
  switchLevels1,
  getAlarmCaseCount
} from '@/api/case'

import {
  Toast
} from 'mint-ui'

const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}

export default {
  created () {
    this.$emit('refr', 'aaa')
    // localStorage.setItem("store",JSON.stringify(this.$store.state))
    if (localStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))))
    }
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    if (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).level == 'ALL') {
      switchLevels('ALL').then(res => {
        // 初始化案件数量
    		this.getCountList()
      })
    } else {
      // 初始化案件数量
    	this.getCountList()
    }

    getAreaList().then(res => {
      if (res.data.success) {
        this.areaList = res.data.data
        console.log(this.areaList)
      }
    })
  },
  data () {
    return {
      tabelmsg: '我的案件',
      Type: this.$route.params.Type,
      now: this.getNow(),
      user: '',
      tab: '',
      areaList: [],
      showbtn: false,
      draft: 0, // 草稿
      untreated: 0, // 未处理
      treating: 0, // 处理中
      closing: 0, // 结案
	  favour: 0, // 收藏夹
      headerShowFlg: true,
      tmciShowFlg: '',
      active: false,
      parttimeFlg: false,
	  count_历史案件_技术支援申请: 0,
	  count_草稿:0,
      count_草稿_三包预警:0,
    count_新案件_技术支援申请:0,
    count_新案件_三包预警:0,
    count_新案件:0,
    count_新案件_三包预警发起:0,
    count_新案件_建议发起案件:0,
    count_处理中案件:0,
    count_处理中案件_技术支援申请:0,
    count_处理中案件_三包预警:0,
    count_处理中案件_三包预警发起:0,
    count_历史案件:0,
    count_历史案件_三包预警:0,
	count_历史案件_三包预警发起:0,
	count_结案_三包预警发起_案件关闭:0
    }
  },
  methods: {
    changeField () {
      console.log(this.user)
      this.active = true
      switchLevels1('SECTION', this.tab).then(res => {
        this.getCountList()
      })
    },
    changeField1 () {
      this.active = false
      this.tab = ''
      switchLevels('ALL').then(res => {
        this.getCountList()
      })
    },
    getNow () {
      const d = new Date()
      const year = d.getFullYear()
      const month = getHandledValue(d.getMonth() + 1)
      const date = getHandledValue(d.getDate())
      const hours = getHandledValue(d.getHours())
      const minutes = getHandledValue(d.getMinutes())
      const second = getHandledValue(d.getSeconds())
      let resStr = year + '-' + month + '-' + date
      this.now = resStr
      this.user = JSON.parse(localStorage.getItem('user'))
      this.showbtn = this.user.admin
      if (this.user.type != 2) {
        this.headerShowFlg = true
      } else {
        this.headerShowFlg = false
      }
      // tmci 分室长 是否有兼职
      if (this.user.type == 1) {
        if (this.user.levels.length > 1) {
          this.parttimeFlg = true
        } else {
          this.parttimeFlg = false
        }
      }

      this.tmciShowFlg = this.user.level
      // todo
      // this.tmciShowFlg = 'SECTION'

      console.info(this.user)
    },
    caseTabelClick (level) {
      // 案件导航tabel切换用户级别
      if (this.tmciShowFlg === level) {
        return
      }
      switchLevel(level).then((res) => {
        if (res.data.success) {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.getCountList()
        } else {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    getCountList () {
      // 初始化案件数量
      getCountList().then((res) => {
        this.draft = res.data[0]
        this.untreated = res.data[1]
        this.treating = res.data[2]
        this.closing = res.data[3]
        this.favour = res.data[5]
        this.count_草稿 = res.data['count_草稿']
        this.count_草稿_三包预警 = res.data['count_草稿_三包预警']
        this.count_新案件 = res.data['count_新案件']
        this.count_新案件_技术支援申请 = res.data['count_新案件_技术支援申请']
        this.count_新案件_三包预警 = res.data['count_新案件_三包预警']
        this.count_新案件_三包预警发起 = res.data['count_新案件_三包预警发起']
        this.count_新案件_建议发起案件 = res.data['count_新案件_建议发起案件']
        this.count_处理中案件 = res.data['count_处理中案件']
        this.count_处理中案件_技术支援申请 = res.data['count_处理中案件_技术支援申请']
        this.count_处理中案件_三包预警 = res.data['count_处理中案件_三包预警']
        this.count_处理中案件_三包预警发起 = res.data['count_处理中案件_三包预警发起']
        this.count_历史案件 = res.data['count_历史案件']
        this.count_历史案件_技术支援申请 = res.data['count_历史案件_技术支援申请']
        this.count_历史案件_三包预警 = res.data['count_历史案件_三包预警']
		this.count_历史案件_三包预警发起 = res.data['count_历史案件_三包预警发起']
		this.count_结案_三包预警发起_案件关闭 = res.data['count_结案_三包预警发起_案件关闭']
		
      })
    }
  },
  mounted () {
    this.getNow()
  },
  computed: {
    ...mapState({
      userName: state => state.user.userName,
      type: state => state.user.type,
      typeName: state => state.user.typeName
    })
  }
}
</script>
<style>
	.header {
		padding-bottom: 0.15rem;
		border-bottom: 1px solid blue;
	}

	.divBack {
		display: block !IMPORTANT;
	}

	.compartmentCase,
	.myCase,
	.allCase {
		display: none;
	}

	.casediv {
		overflow-x: hidden;
		margin-left: 10px;
		margin-right: 10px;
	}

	.el-row {
		margin-bottom: 20px;

	}

	.el-header,
	.el-footer {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.el-col {
		border-radius: 4px;
	}

	.bg-purple-dark {
		background: #67c23a;
	}

	.bg-purple {
		background: #409eff;
	}

	.bg-purple-light {
		background: #e6a23c;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.divcenter {
		text-align: center;
		line-height: 44px;
		color: #fff;
		font-size: 14px;
	}

	.divcenter-f {
		text-align: center;
		line-height: 44px;
		color: #000;
		font-size: 14px;
	}

	.divleft {
		text-align: left;
		line-height: 44px;
		color: #333;
		font-size: 14px;
		padding-left: 10px;
	}

	.frontleft {
		float: left;
		width: 40%;
	}

	.divright {
		text-align: left;
		line-height: 44px;
		color: #333;
		font-size: 14px;
		padding-right: 10px;
	}

	.frontright {
		float: right;
		width: 5%;
	}

	.bg-purple-new {
		background: #fff;
	}

	.bg-purple-new.bg-purple-new-item{
		text-indent: 40px;
		
	}

	.bg-purple-new span.bgr {
		text-indent: 0;
		float: right;
		border-radius: 20px;
		background: #e63c3c;
		font-size: 12px;
		display: block;
		height: 20px;
		position: relative;
		top: 11px;
		right: 15px;
		line-height: 23px !IMPORTANT;
		color: #fff;
		text-align: center;
		padding: 0 8px;
	}

	.addCase {
		color: #fff;
		background-color: #00ae66;
	}

	.addCase a {
		color: #fff;
	}
	.active {
		background: #fff;
		color: #333;
	}

	/* .container{width: 100%;} */
</style>
